<div class="page-layout">
  <p class="head-text" *ngIf="portfolioActivity">
    <span class="portfolio-activity-teacher-info">
      <span class="teacher-name fw-bold">{{ portfolioActivity.teacherFirstName }} {{ portfolioActivity.teacherLastName }}</span>
      <span class="grey-text">
        <span class="mx-2">•</span>
        <span>{{ portfolioActivity.teacherGroups | formatTeacherGroups }}</span>
      </span>
    </span>
  </p>
  <div class="portfolio-detail d-flex flex-wrap flex-xl-nowrap flex-column-reverse flex-xl-row" *transloco="let t">
    <div class="activities-list d-flex flex-column">
      <div *ngIf="portfolioActivity; else loading" class="portfolio-list d-flex flex-column">
        <isophi-app-portfolio-plan-description
          [control]="form.controls.description"
          [title]="t('pap/portfolio/description')"
          [allowEditMode]="false"
        ></isophi-app-portfolio-plan-description>
        <isophi-app-portfolio-plan-self-reflection [form]="form.controls.selfReflection" [allowEditMode]="false">
        </isophi-app-portfolio-plan-self-reflection>
        <isophi-app-portfolio-plan-competence
          [control]="form.controls.competenceUuids"
          [fetchCategories]="fetchCategories"
          [allowEditMode]="false"
          [materialServer]="materialServer"
        ></isophi-app-portfolio-plan-competence>
        <isophi-portfolio-plan-documents
          [documents]="portfolioActivity?.documents"
          [allowDownload]="true"
          (downloadDocument)="downloadDocument($event)"
        >
        </isophi-portfolio-plan-documents>
        <isophi-app-portfolio-linked-targets
          [teacherActivityId]="portfolioActivityId"
          [allowEditMode]="false"
          [fetchTeacherActivityTargetLinks]="fetchPortfolioActivityTargetLinks"
          [fetchTeacherTargets]="fetchPortfolioTargets"
          [buildTeacherTargetRouteLink]="buildPortfolioTargetRouteLink"
        ></isophi-app-portfolio-linked-targets>
      </div>
      <ng-template #loading>
        <div class="text-center">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </ng-template>
    </div>
    <div class="activity-description d-flex flex-column">
      <div class="activity-description-header">
        <div class="activity-type">
          <span>{{ activityTypeData[portfolioActivity?.activityType] }}</span>
          <span
            *ngIf="portfolioActivity?.recommendToOthers"
            [ngbTooltip]="t('pap/portfolio/recommended')"
            placement="top"
            class="material-symbols-rounded thumb-up text-success"
          >
            thumb_up
          </span>
          <span
            *ngIf="!portfolioActivity?.recommendToOthers"
            [ngbTooltip]="t('pap/portfolio/unrecommended')"
            placement="top"
            class="material-symbols-rounded thumb-down text-primary"
          >
            thumb_down
          </span>
        </div>
        <button (click)="printPage()" class="btn btn-outline-primary btn-icon activity-print-button">
          <isophi-print-download-icon class="print-icon"></isophi-print-download-icon>
          {{ t('shared/printDownload') }}
        </button>
      </div>
      <div class="activity-info">
        <div class="info-item">
          <div class="info-title">{{ t('pap/portfolio/dateLabel') }}</div>
          <div class="info-content">
            <span class="material-symbols-rounded"> calendar_month </span>
            {{ portfolioActivity?.dateStart | date : 'd. M. y' }} - {{ portfolioActivity?.dateEnd | date : 'd. M. y' }}
          </div>
        </div>
        <div class="info-item">
          <div class="info-title">{{ t('pap/portfolio/hoursLabel') }}</div>
          <div class="info-content">
            <span class="material-symbols-rounded"> hourglass </span>
            {{ portfolioActivity?.hourTime }}
          </div>
        </div>
        <div class="info-item">
          <div class="info-title">{{ t('pap/portfolio/organizerLabel') }}</div>
          <div class="info-content align-items-start">
            <span class="material-symbols-rounded"> account_balance </span>
            <div class="d-flex flex-column">
              <div *ngIf="portfolioActivity?.organizer">{{ portfolioActivity?.organizer }}</div>
              <a *ngIf="portfolioActivity?.organizerWebsite" href="{{ organizerWebsiteHref() }}" target="_blank">{{
                portfolioActivity?.organizerWebsite
              }}</a>
            </div>
          </div>
        </div>
        <div class="info-item">
          <div class="info-title">{{ t('pap/portfolio/studyType') }}</div>
          <div class="info-content align-items-start">
            <span class="material-symbols-rounded"> co_present </span>
            <div class="d-flex flex-column">
              <div *ngIf="portfolioActivity?.studyType">{{ studyTypeData[portfolioActivity?.studyType] }}</div>
              <div *ngIf="portfolioActivity?.lector" class="text-gray">{{ portfolioActivity?.lector }}</div>
            </div>
          </div>
        </div>
        <div class="info-item">
          <div class="info-title">{{ t('pap/portfolio/priceLabel') }}</div>
          <div class="info-content align-items-start">
            <span class="material-symbols-rounded"> shoppingmode </span>
            <div class="d-flex flex-column">
              <div>{{ portfolioActivity?.price ?? 0 | currency : 'CZK' : 'symbol' : '1.0-0' }}</div>
              <div *ngIf="portfolioActivity?.selfPayer" class="text-gray">{{ t('pap/portfolio/selfPayer') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
